import { FC } from "react"
import { themeStore, LongShortStatistics } from "@root/common"
import { LowerInfoStyled } from "./LowerInfo.styled"
import { observer } from "mobx-react-lite"
import Row from "./Row/Row"

interface IOrderBookPanel {
    statistics?: LongShortStatistics
}

const OrderBookPanel: FC<IOrderBookPanel> = observer(({ statistics }) => (
    <LowerInfoStyled>
        {statistics && [statistics.long, statistics.short]?.map((longShort, i) => {
            const asks = longShort.orderbook?.asks || []
            const bids = longShort.orderbook?.bids || []
            const isSingleOrderLayout = asks.length === 1 || bids.length === 1

            const askRows = [...asks].reverse().map((ask) =>
                <Row
                    key={Math.random()}
                    price={ask.price}
                    volume={ask.volume}
                    color={themeStore.redColor}
                    width={100 * parseInt(ask.volume) / Math.max(...(asks.map(ask => parseInt(ask.volume)) || []))}
                />
            )

            const bidRows = bids.map((bid) =>
                <Row
                    key={Math.random()}
                    price={bid.price}
                    volume={bid.volume}
                    color={themeStore.greenColor}
                    width={100 * parseInt(bid.volume) / Math.max(...(bids.map(bid => parseInt(bid.volume)) || []))}
                />
            )

            return (
                <div key={i} className={isSingleOrderLayout ? "orderbook single-order" : "orderbook"}>
                    <div className="headers">
                        <h3 style={{ color: themeStore.textColor }}>Цена</h3>
                        <h3 style={{ color: themeStore.textColor }}>Объем $</h3>
                    </div>

                    {isSingleOrderLayout
                        ? <div className="orders-centered">{askRows}{bidRows}</div>
                        : <>{askRows}{bidRows}</>
                    }
                </div>
            )
        })}
    </LowerInfoStyled>
))

export default OrderBookPanel
